import { apiPost, apiGet } from '../api';

import { deleteCookie } from '../services/cookies';
import { sendGTMEvents } from './Booking';

export const LOYALTY_STATUS = Object.freeze({
  BECOME_MEMBER: 'becomeMember',
  IS_MEMBER: 'isMember',
  DONT_WANT_MEMBER: 'dontWantMember',
});

export const setShowClaimPopup = (show) => ({ type: 'LOYALTY_SET_SHOW_CLAIM_POPUP', show });

export const setShowLogin = (show) => ({ type: 'LOYALTY_SET_SHOW_LOGIN', show });

export const setShowLastChanceToRegister = (show) => ({ type: 'LOYALTY_SET_SHOW_LAST_CHANCE_TO_REGISTER', show });

export const setLastChanceRegisterConfirmed = (show) => ({
  type: 'LOYALTY_SET_LAST_CHANCE_TO_REGISTER_CONFIRMED',
  show,
});

export const setShowRecoverPassword = (show) => ({ type: 'LOYALTY_SET_SHOW_RECOVER_PASSWORD', show });

export const setLoggedUser = (user) => ({ type: 'LOYALTY_SET_LOGGED_USER', user });

export const setHasRegistered = (hasRegistered) => ({ type: 'LOYALTY_SET_HAS_REGISTERED', hasRegistered });

export const setMaxCoinsToApply = (coins) => ({ type: 'LOYALTY_SET_MAX_COINS_TO_APPLY', coins });

export const setCoinsEntered = (coins) => ({ type: 'LOYALTY_SET_COINS_ENTERED', coins });

export const setStateCoinsApplied = (coins) => ({ type: 'LOYALTY_SET_COINS_APPLIED', coins });

export const setNewMember = (newMember) => ({ type: 'LOYALTY_SET_NEW_MEMBER', newMember });

export const setNewMemberDiscountPercentage = (newMemberDiscountPercentage) => ({
  type: 'LOYALTY_SET_NEW_MEMBER_DISCOUNT_PERCENTAGE',
  newMemberDiscountPercentage,
});

export const setCurrentStays = (currentStays) => ({ type: 'LOYALTY_SET_CURRENT_STAYS', currentStays });

export const setCurrentNights = (currentNights) => ({ type: 'LOYALTY_SET_CURRENT_NIGHTS', currentNights });

export const setOptinAccepted = (optinAccepted) => ({ type: 'LOYALTY_SET_OPTIN_ACCEPTED', optinAccepted });

export const setSaNetRatePercentage = (saNetRatepercentage) => ({
  type: 'LOYALTY_SET_SA_NET_RATE_PERCENTAGE',
  saNetRatepercentage,
});

export const setNightsNeededToUpgrade = (nightsNeededToUpgrade) => ({
  type: 'LOYALTY_SET_NIGHTS_NEEDED_TO_UPGRADE', nightsNeededToUpgrade,
});

export const setProgramType = (programType) => ({ type: 'LOYALTY_SET_PROGRAM_TYPE', programType });

export const setIsAgencyAdmin = (isAgencyAdmin) => ({ type: 'LOYALTY_SET_IS_AGENCY_ADMIN', isAgencyAdmin });

export const setNextLoyaltyLevel = (nextLoyaltyLevel) => ({ type: 'LOYALTY_SET_NEXT_LOYALTY_LEVEL', nextLoyaltyLevel });

export const setAgencySchema = (agencySchema) => ({ type: 'LOYALTY_SET_AGENCY_SCHEMA', agencySchema });

export const setCheckoutCoins = (checkoutCoins) => ({ type: 'LOYALTY_SET_CHECKOUT_COINS', checkoutCoins });

export const setDiscountApplied = (discount) => ({ type: 'LOYALTY_SET_DISCOUNT_APPLIED', discount });

export const setShowRegistration = (show) => ({ type: 'LOYALTY_SET_SHOW_REGISTRATION', show });

export const setMemberInfo = (memberInfo) => ({ type: 'LOYALTY_SET_MEMBER_INFO', memberInfo });

export const setSelectedStatus = (selectedStatus) => ({ type: 'LOYALTY_SET_SELECTED_STATUS', selectedStatus });

export const setMaxPercentUsage = (percent) => ({ type: 'LOYALTY_SET_MAX_PERCENT_USAGE', percent });

export const setConversionRates = (conversionRates) => ({ type: 'LOYALTY_SET_CONVERSION_RATES', conversionRates });

export const setCoinsApplied = (coins) => (dispatch, getState) => {
  dispatch(setStateCoinsApplied(coins));
  const state = getState();
  const { memberInfo } = state.loyalty;
  const { cart } = state;
  const email = memberInfo !== null ? memberInfo.email : '';
  if (cart.amount !== null) {
    dispatch(checkCoinsToRedeem({ coins, email }));
  }
};

/*export const setNewMember = newMember => (dispatch) => {
  dispatch(setStateNewMember(newMember));
};

export const setNewMemberDiscountPercentage = newMemberDiscountPercentage => (dispatch) => {
  dispatch(setStateNewMemberDiscountPercentage(newMemberDiscountPercentage));
};*/

export const login = (payload) => (dispatch, getState) => {
  const state = getState();
  const {
    session, bookingFormState, i18nState, loyalty,
  } = state;
  return apiPost('api-pb/loyalty/login/', {
    username: payload.email,
    password: payload.password,
    brand_id: session.chainData.loyalty_brand_id,
    lang: i18nState.lang,
    session_key: bookingFormState.sessionId,
  }).then((response) => {
    if (response && response.success) {
      // dispatch(setLoggedUser(response.user)); No es necesario. Quitando Ã©sto se
      // corrige un error donde el usuario no podÃ­a elegir mÃ¡s de 20 coins si se
      // logueaba en el confirmation form
      dispatch(getMemberInfo({ email: response.user.email }));
      if (loyalty.hasRegistered === false) {
        dispatch(sendGTMEvents([{ event: 'login', languageCode: i18nState.lang }]));
      }
    }
    return response;
  });
};

export const logout = (newMember = false, newMemberDiscountPercentage = 0) => (dispatch, getState) => {
  const state = getState();
  const { bookingFormState } = state;
  return apiPost('api-pb/loyalty/logout/', {
    session_key: bookingFormState.sessionId,
  }).then((response) => {
    if (response.success) {
      deleteCookie('login-details');
      dispatch(setLoggedUser(null));
      dispatch(setHasRegistered(false));
      const memberInfo = {
        accountHolder: null, email: '', availableCoins: 0, cardCode: '',
      };
      dispatch(setMemberInfo(memberInfo));
      dispatch(setNewMember(newMember));
      dispatch(setNewMemberDiscountPercentage(newMemberDiscountPercentage));
      dispatch(setCurrentStays(0));
      dispatch(setCurrentNights(0));
      dispatch(setOptinAccepted(false));
      dispatch(setSaNetRatePercentage(0));
      dispatch(setCoinsApplied(0));
      dispatch(setCoinsEntered(0));
      dispatch(setMaxCoinsToApply(0));
    }
    return response;
  });
};

/**
 * It make a call to loyalty api so check coins to redeem are valid or not.
 */
export const checkCoinsToRedeem = ({ coins = 0, email }) => (dispatch, getState) => {
  const state = getState();
  const { bookingFormState } = state;
  return apiPost('api-pb/loyalty/redeem-details/', {
    session_key: bookingFormState.sessionId,
    member_email: email,
    coins_to_expend: coins,
  }).then((response) => {
    if (response && response.success) {
      return response.details;
    }
    return null;
  });
};

/**
 * Hace una llamada para saber cuántos checkout coins obtendría el usuario
 * en caso de que decidiera ser parte de loyalty. Esto se usa para el pop up
 * de last chance to register
 */
export const checkOutCoinsInCaseUserDecidesToRegister = () => (dispatch, getState) => {
  const state = getState();
  const { bookingFormState } = state;
  return apiPost('api-pb/loyalty/checkout-coins/', {
    session_key: bookingFormState.sessionId,
  }).then((response) => {
    if (response && response.success) {
      dispatch(setCheckoutCoins(response.checkout_coins));
      return response.checkout_coins;
    }
    return null;
  });
};

export const memberRegistration = (formData) => (dispatch, getState) => {
  const state = getState();
  const { session, booking, i18nState } = state;
  const payload = {
    ...formData,
    brand_id: session.chainData.loyalty_brand_id,
    currency_code: booking && booking.filterCurrency ? booking.filterCurrency.code : null,
    lang_code: i18nState.lang,
    hotel_code: booking.hotel.code,
  };
  return apiPost('api-pb/loyalty/member-registration/', payload);
};

export const getMemberInfo = ({ email, callcenter_email = null, hotel_code = '' }) => (dispatch, getState) => {
  const state = getState();
  const {
    bookingFormState, session, i18nState, booking,
  } = state;
  const brand_id = session.chainData.loyalty_brand_id;
  const { lang } = i18nState;
  return apiPost('api-pb/loyalty/member-info/', {
    session_key: bookingFormState.sessionId,
    member_email: email,
    callcenter_email,
    brand_id,
    lang,
    hotel_code: booking.hotel != null ? booking.hotel.code : hotel_code,
  }).then((response) => {
    if (response == null) {
      return null;
    }
    const jsonObject = JSON.parse(JSON.stringify(response));
    const user1 = jsonObject.user;

    if (response.success) {
      const {
        account_holder, available_coins, discount_available_percentage, membership_name,
        new_member, new_member_discount_percentage, current_stays, current_nights, card_code,
        optin_accepted, program_type, is_agency_admin, nights_to_upgrade, next_level_name,
        agency_schema, sa_net_rate_percentage,
      } = response.info;

      const memberInfo = {
        accountHolder: account_holder,
        email: user1 ? user1.email : email,
        availableCoins: available_coins,
        discountAvailablePercentage: discount_available_percentage,
        membershipName: membership_name,
        cardCode: card_code,
      };
      dispatch(setNewMember(new_member));
      dispatch(setNewMemberDiscountPercentage(new_member_discount_percentage));
      dispatch(setCurrentStays(current_stays));
      dispatch(setCurrentNights(current_nights));
      dispatch(setOptinAccepted(optin_accepted));
      dispatch(setSaNetRatePercentage(sa_net_rate_percentage));
      dispatch(setProgramType(program_type));
      dispatch(setIsAgencyAdmin(is_agency_admin));
      dispatch(setNightsNeededToUpgrade(nights_to_upgrade));
      dispatch(setNextLoyaltyLevel(next_level_name));
      dispatch(setAgencySchema(agency_schema));
      dispatch(setMemberInfo(memberInfo));
      dispatch(setLoggedUser(response.user));
      dispatch(setMaxPercentUsage(discount_available_percentage));
      dispatch(setCoinsApplied(0));
      return jsonObject;
    }
    return null;
  });
};

export const resetPassword = (email) => (dispatch, getState) => {
  const state = getState();
  const { session, i18nState } = state;
  return apiPost('api-pb/loyalty/reset-password/', {
    email,
    brand_id: session.chainData.loyalty_brand_id,
    lang: i18nState.lang,
  }, i18nState.lang);
};

/**
 * Pre-check del email en loyalty (Django -> gateway checkRegistrationEmail).
 * Resuelve con el status: NOT_FOUND, INVALID_EMAIL, PENDING_VERIFICATION,
 * UNSUBSCRIBED, ACTIVE o BLOCKED.
 * Se rechaza si el check no se pudo completar, para que el formulario
 * no se bloquee por un error técnico.
 */
export const checkRegistrationEmail = (email) => () => apiPost('api-pb/loyalty/check-registration-email/', {
  email: (email || '').trim(),
}).then((response) => {
  if (response && response.success && response.status) {
    return response.status;
  }
  throw new Error((response && response.error_message) || 'Email check failed');
});

/**
 * Reenvía el link de activación (sólo PENDING_VERIFICATION o UNSUBSCRIBED).
 * Se rechaza con un Error cuyo `code` es el error_code del backend (p. ej. THROTTLED).
 */
export const resendActivationLink = (email) => () => apiPost('api-pb/loyalty/resend-activation-link/', {
  email: (email || '').trim(),
}).then((response) => {
  if (response && response.success) {
    return response;
  }
  const error = new Error((response && response.error_message) || 'Activation link could not be sent');
  error.code = response ? response.error_code : null;
  throw error;
});

export const getConversionRates = (hotel_code) => (dispatch) => {
  const url = `api-pb/loyalty/coin-conversion-rates/${hotel_code}/`;
  return apiGet(url)
    .then((response) => {
      if (response.success) {
        dispatch(setConversionRates(response.conversion_rates));
      }
      return response;
    });
};
